var _path, _path2, _path3, _path4, _g, _path5, _path6, _g2, _path7, _path8, _g3, _path9, _g4, _path10, _g5, _path11, _g6, _path12, _g7, _path13, _g8, _path14, _g9, _path15, _g10, _path16, _g11, _path17, _g12, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoSvg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_640_13290",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 6,
    width: 60,
    height: 48
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.7352 6.72339H0V53.2767H59.7352V6.72339Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_640_13290)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_640_13290",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 6,
    width: 60,
    height: 48
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7352 6.72339H0V53.2767H59.7352V6.72339Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_640_13290)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_640_13290",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 14,
    width: 42,
    height: 32
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4821 14.6753H16.3672V45.2507H57.4821V14.6753Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_640_13290)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_640_13290",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 14,
    width: 41,
    height: 32
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7954 14.9503C49.4373 14.9519 48.0971 15.7107 47.2103 16.7716C46.1559 18.0337 45.6411 19.6571 45.2937 21.2641C44.9472 22.8719 44.7411 24.5183 44.1926 26.0686C43.2277 28.7965 41.2619 31.0563 39.1187 32.9999C36.6027 35.2827 33.7287 37.2543 30.4811 38.2536C26.5018 39.4788 22.2211 39.1758 18.0973 38.5985C17.5545 38.5222 16.942 38.3505 16.4041 38.3817C16.4041 38.3867 16.4041 38.3908 16.4041 38.3957V38.4097C16.4164 39.0658 18.1326 39.9953 18.6187 40.3353C19.5245 40.9675 20.4622 41.553 21.4279 42.0892C23.3904 43.1797 25.4671 44.0657 27.6144 44.7235C28.5407 45.0076 29.4973 45.2515 30.4655 45.2137C31.6758 45.1669 32.8271 44.6857 34.0268 44.5247C35.2412 44.3622 36.4894 44.5297 37.6924 44.2932C38.8272 44.0698 39.8602 43.4991 40.871 42.9366L47.244 39.3901C48.3583 38.7701 49.4832 38.1428 50.4349 37.2937C51.6018 36.2533 52.4632 34.9198 53.2663 33.5788C55.5195 29.8155 57.482 25.4429 56.5098 21.1656C56.1354 19.5175 55.3257 17.9696 54.1843 16.7223C53.4724 15.9439 52.5954 15.2631 51.5657 15.0332C51.3144 14.9774 51.0607 14.9503 50.8069 14.9495H50.7946L50.7954 14.9503Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_640_13290)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.482 14.9507H16.4041V45.2519H57.482V14.9507Z",
    fill: "url(#paint0_linear_640_13290)"
  }))))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_640_13290",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 13,
    width: 51,
    height: 36
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0377 13.9224H1.3615V48.3317H51.0377V13.9224Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_640_13290)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_640_13290",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 13,
    width: 51,
    height: 36
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0377 13.9224H1.3615V48.3317H51.0377V13.9224Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_640_13290)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.1741 15.8496C35.4794 18.6817 31.1347 23.5626 26.3868 27.7948C25.2101 28.8434 23.9833 29.8699 22.5529 30.5309C18.5917 32.3629 13.7633 31.2207 10.5305 28.2875C12.0274 26.0548 12.9208 23.4772 11.4896 20.3831C9.66334 20.9169 8.485 22.4697 8.11794 24.3362C8.04404 24.7139 8.00791 25.1105 7.81741 25.4447C7.6269 25.7789 7.21961 26.0326 6.85913 25.898C4.96638 25.1918 2.65978 25.8003 1.36154 27.3473C2.03324 28.5462 3.3052 29.3279 4.64203 29.6465C5.97886 29.9651 7.3822 29.8658 8.73709 29.6367C9.94993 34.3106 13.8282 38.0789 18.6344 38.556C22.2318 38.9132 26.3491 39.1809 29.8693 38.354C28.4479 41.191 26.992 44.1743 27.0676 47.3472C27.075 47.6551 27.116 48.0008 27.3574 48.1921C27.6063 48.3892 27.9626 48.3408 28.2714 48.2726C34.4086 46.9144 39.182 40.9159 39.127 34.6301C39.1212 33.9592 39.1064 33.1881 39.6106 32.7463C41.8376 30.792 43.5168 28.2202 44.4102 25.3954C45.0753 23.2916 45.3135 21.0581 46.1281 19.0077C46.817 17.2743 48.0849 15.448 49.9751 14.9398C50.279 14.8585 50.6123 14.8667 50.9063 14.7648C51.0221 14.7246 51.0779 14.6236 51.004 14.5103C50.8866 14.3296 50.623 14.2771 50.4292 14.2393C49.3527 14.0283 48.1793 13.8542 47.0814 13.9511C45.8875 14.0562 44.719 14.383 43.5973 14.7961C42.7696 15.1007 41.9624 15.4579 41.1732 15.8504",
    fill: "white"
  }))))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask6_640_13290",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 46,
    y: 37,
    width: 6,
    height: 7
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2956 37.2109H46.8803V43.3925H51.2956V37.2109Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_640_13290)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask7_640_13290",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 46,
    y: 37,
    width: 6,
    height: 7
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2956 37.2109H46.8803V43.3925H51.2956V37.2109Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_640_13290)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.6749 41.4405C50.5525 41.7378 50.417 42.0342 50.2216 42.2888C49.9777 42.6057 49.6501 42.8463 49.3274 43.0828C49.1065 43.2446 48.8577 43.4146 48.5851 43.3899C48.2147 43.3571 47.9766 42.9909 47.8123 42.6575C47.4198 41.8618 47.1136 41.0234 46.9017 40.162C46.8845 40.0922 46.868 40.0167 46.8943 39.9493C46.9206 39.8812 46.9838 39.836 47.0438 39.7949C48.117 39.0649 49.2321 38.3842 50.215 37.5302C50.6576 37.1459 50.9976 37.0047 51.1848 37.6961C51.3367 38.2545 51.3113 38.8843 51.2341 39.4517C51.1405 40.1357 50.9368 40.8033 50.6749 41.4405Z",
    fill: "white"
  })))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_640_13290",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 39,
    y: 23,
    width: 4,
    height: 4
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0876 23.7457C39.2459 24.2179 38.979 25.2418 39.3313 26.109C39.5136 26.5581 40.228 26.3151 40.0449 25.8651C39.8396 25.3593 39.9012 24.7598 40.393 24.4404C40.8512 24.1423 41.4039 24.2992 41.6855 24.7475C41.9434 25.1597 42.5666 24.7335 42.3088 24.3221C41.9935 23.8188 41.4507 23.5347 40.8923 23.5347C40.6197 23.5347 40.3438 23.6028 40.0884 23.7457",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_640_13290)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.1214 21.8684L37.5756 25.6018L41.4311 28.2309L43.9769 24.4975L40.1214 21.8684Z",
    fill: "url(#paint1_linear_640_13290)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_640_13290",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 39,
    width: 10,
    height: 2
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9356 39.7433C26.3195 40.1998 23.6548 40.3542 21.0066 40.1325C20.7069 40.107 20.6117 40.5693 20.913 40.5948C23.6047 40.8198 26.3047 40.6786 28.9644 40.2146C29.2452 40.1653 29.2353 39.74 28.98 39.74C28.966 39.74 28.9512 39.7416 28.9356 39.7441",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_640_13290)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.1534 36.0447L20.1488 40.0061L22.7043 44.5248L29.709 40.5634L27.1534 36.0447Z",
    fill: "url(#paint2_linear_640_13290)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_640_13290",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 38,
    y: 18,
    width: 11,
    height: 19
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8195 18.686C48.0551 20.2108 48.12 21.7595 47.9238 23.2926C47.2126 28.8485 43.5043 33.4001 38.7934 36.197C38.5323 36.3522 38.7992 36.7406 39.0595 36.5862C40.4924 35.7355 41.8399 34.7468 43.0494 33.5988C45.1171 31.6363 46.7052 29.1991 47.6429 26.5049C48.5248 23.9725 48.6989 21.3005 48.29 18.6572C48.2678 18.5152 48.1496 18.447 48.0363 18.447C47.9123 18.447 47.7948 18.5291 47.8186 18.686",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_640_13290)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.2375 14.096L30.695 22.886L40.9975 41.1031L56.54 32.3132L46.2375 14.096Z",
    fill: "url(#paint3_linear_640_13290)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_640_13290",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 41,
    width: 7,
    height: 2
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8468 42.1428C24.6476 42.3111 26.4549 42.3226 28.259 42.188C28.5628 42.165 28.5324 41.6945 28.2302 41.7175C26.4681 41.8497 24.7001 41.8464 22.9396 41.6813C22.9305 41.6813 22.9215 41.6797 22.9133 41.6797C22.6341 41.6797 22.5528 42.1157 22.846 42.1428",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_640_13290)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.1059 39.1098L22.2777 41.8403L24.0098 44.9031L28.838 42.1725L27.1059 39.1098Z",
    fill: "url(#paint4_linear_640_13290)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_640_13290",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 17,
    width: 15,
    height: 23
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3371 17.8427C50.9793 19.7568 51.224 21.7875 51.0532 23.8001C50.7502 27.3573 49.2229 30.692 46.8736 33.3615C44.4586 36.105 41.3004 38.0749 37.937 39.4462C37.657 39.5604 37.8081 40.0071 38.0897 39.8921C40.0925 39.0759 42.0173 38.0651 43.7704 36.7939C46.7381 34.6425 49.1999 31.7439 50.5055 28.2926C51.7881 24.9013 51.9409 21.1379 50.7839 17.6908C50.7477 17.5824 50.6623 17.5364 50.5745 17.5364C50.4291 17.5364 50.2772 17.6637 50.338 17.8427",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_640_13290)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.4813 11.4205L28.0291 22.9871L41.1192 46.1332L61.5714 34.5666L48.4813 11.4205Z",
    fill: "url(#paint5_linear_640_13290)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_640_13290",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 36,
    y: 16,
    width: 19,
    height: 27
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5379 17.3104C53.6834 19.2803 54.2097 21.5204 54.1095 23.795C53.9313 27.849 51.9072 31.7068 49.213 34.6629C45.8783 38.3203 41.362 40.5464 36.6757 41.9383C36.3842 42.0245 36.5386 42.4704 36.8285 42.3841C39.6655 41.5416 42.4303 40.4175 44.9357 38.8286C48.6817 36.453 51.7923 33.0042 53.446 28.8582C54.9832 25.0045 55.0506 20.6927 52.9287 17.0443C52.8844 16.968 52.8203 16.9368 52.7546 16.9368C52.5953 16.9368 52.4311 17.1248 52.5387 17.3104",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_640_13290)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.528 8.94391L25.4442 23.1299L40.9087 50.4745L65.9926 36.2885L50.528 8.94391Z",
    fill: "url(#paint6_linear_640_13290)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_640_13290",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 13,
    width: 41,
    height: 36
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4288 42.9113C48.1011 42.6699 47.9197 41.9949 47.7596 41.6328C47.5715 41.2074 47.3974 40.7763 47.2332 40.3411C47.2217 40.3108 47.2077 40.2845 47.1921 40.2607C48.4477 39.4173 49.6334 38.4714 50.7313 37.4269C50.9505 38.7506 50.7403 40.1301 50.1359 41.3339C49.9512 41.7018 49.2688 42.9959 48.6743 42.9959C48.5897 42.9959 48.5076 42.9696 48.4288 42.9113ZM39.3929 33.4468C40.6024 32.3678 41.6987 31.1714 42.6167 29.8321C43.4649 28.5946 44.1703 27.2619 44.6745 25.8479C45.2066 24.355 45.4152 22.8277 45.6656 21.27C45.9259 19.649 46.3849 18.0691 47.5198 16.8341C48.671 15.5811 50.3486 15.0219 52.0164 15.3758C52.0599 15.3848 52.101 15.3873 52.1387 15.3832C52.326 15.4932 52.5091 15.6114 52.6864 15.742C53.7515 16.5262 54.5907 17.583 55.1852 18.7605C58.0124 24.3624 55.6212 30.8749 51.7454 35.2755C47.6175 39.9609 41.9581 42.8563 35.8882 44.0552C38.2293 41.1147 39.7665 37.2027 39.3929 33.4468ZM40.6714 15.3405C34.861 18.1652 30.6419 23.111 26.0763 27.5214C24.9341 28.625 23.7081 29.7015 22.2703 30.4036C20.8908 31.0769 19.3569 31.3422 17.8287 31.2404C17.6242 31.2264 17.4206 31.2067 17.2178 31.1812V31.9359C17.7195 31.9966 18.2253 32.0229 18.7353 32.0106C21.8105 31.9383 24.2501 30.2969 26.4081 28.244C30.9301 23.9445 35.0129 19.0266 40.6829 16.169C43.2046 14.8987 46.0704 14.0529 48.9157 14.3797C49.3263 14.4273 49.7319 14.4963 50.1302 14.5916C49.0488 14.7747 48.0346 15.2838 47.2118 16.0713C44.6893 18.4871 45.1122 22.1059 44.112 25.1795C43.1899 28.0132 41.4383 30.5284 39.2664 32.5517C39.1465 31.8989 38.9659 31.2535 38.7171 30.622C38.5397 30.1712 37.8253 30.4143 38.0035 30.8659C38.9708 33.3211 38.8386 36.017 38.0388 38.5009C37.3219 40.7238 36.0886 42.8021 34.5013 44.5134C32.8647 46.278 30.6772 47.7717 28.2474 48.1174C27.9682 48.1568 27.6225 48.2036 27.3565 48.0813C27.0453 47.9384 27.06 47.6461 27.1069 47.3447C27.2013 46.7305 27.391 46.1122 27.5503 45.5119C27.8968 44.2104 28.3 42.9236 28.7442 41.6525C29.6171 39.1513 30.6329 36.7034 31.6478 34.2572C31.8334 33.8097 31.1568 33.4763 30.9704 33.9255C30.4284 35.2303 29.8881 36.5359 29.3675 37.8498C25.435 38.8795 21.1658 39.0257 17.2169 37.9746V38.7489C21.0624 39.731 25.1763 39.63 29.0316 38.7087C28.447 40.2212 27.896 41.7461 27.4107 43.294C27.3573 43.4656 27.3039 43.6372 27.2522 43.8088C25.4375 43.3958 23.6777 42.7906 21.9837 42.0179C20.3061 41.2526 18.7057 40.3296 17.2169 39.2605V40.2081C20.1862 42.2519 23.5546 43.7325 27.0395 44.5323C26.9525 44.8361 26.8679 45.1399 26.7874 45.4454C26.6109 46.113 26.3703 46.8233 26.3251 47.5147C26.2373 48.8532 27.5963 49.0042 28.6005 48.8154C31.1494 48.3358 33.378 46.8454 35.1139 44.9576C35.8586 44.8312 36.5993 44.685 37.3342 44.5126C40.595 43.7464 43.7351 42.4581 46.5533 40.6737C46.7701 41.2411 47.0041 41.8011 47.2619 42.3513C47.4713 42.7988 47.67 43.3745 48.1365 43.6192C49.0997 44.1242 49.9356 43.0756 50.3987 42.3751C51.4818 40.7353 51.8168 38.6997 51.3685 36.7954C52.1207 36.0276 52.8277 35.2106 53.4813 34.3443C56.995 29.6826 58.6759 22.9156 55.4225 17.643C54.7442 16.5443 53.8442 15.5827 52.7595 14.879C51.6058 14.1309 50.2755 13.7606 48.9149 13.6226C48.5068 13.5807 48.0987 13.561 47.6922 13.561C45.2559 13.561 42.8581 14.2738 40.6714 15.3372",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_640_13290)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.7704 -5.63648L0.805481 24.5901L30.1186 68.1961L75.0835 37.9696L45.7704 -5.63648Z",
    fill: "url(#paint7_linear_640_13290)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_640_13290",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 37,
    width: 4,
    height: 4
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2099 40.3567L15.6783 37.9211C16.2531 39.4403 18.2099 40.3567 18.2099 40.3567Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_640_13290)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6915 36.4019H15.6783V40.3565H15.6915V36.4019Z",
    fill: "#052335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7151 36.4019H15.6913V40.3565H15.7151V36.4019Z",
    fill: "#052335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7391 36.4019H15.7153V40.3565H15.7391V36.4019Z",
    fill: "#042436"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7612 36.4019H15.7383V40.3565H15.7612V36.4019Z",
    fill: "#022537"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.785 36.4019H15.7611V40.3565H15.785V36.4019Z",
    fill: "#012639"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8088 36.4019H15.785V40.3565H15.8088V36.4019Z",
    fill: "#022739"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8318 36.4019H15.808V40.3565H15.8318V36.4019Z",
    fill: "#02283A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8548 36.4019H15.8318V40.3565H15.8548V36.4019Z",
    fill: "#02293B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8786 36.4019H15.8548V40.3565H15.8786V36.4019Z",
    fill: "#032A3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9017 36.4019H15.8779V40.3565H15.9017V36.4019Z",
    fill: "#042B3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9254 36.4019H15.9016V40.3565H15.9254V36.4019Z",
    fill: "#042C40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9476 36.4019H15.9246V40.3565H15.9476V36.4019Z",
    fill: "#052D41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9722 36.4019H15.9484V40.3565H15.9722V36.4019Z",
    fill: "#062E42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9952 36.4019H15.9714V40.3565H15.9952V36.4019Z",
    fill: "#072F43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0182 36.4019H15.9952V40.3565H16.0182V36.4019Z",
    fill: "#073044"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0419 36.4019H16.0181V40.3565H16.0419V36.4019Z",
    fill: "#083145"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0649 36.4019H16.0411V40.3565H16.0649V36.4019Z",
    fill: "#093246"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.088 36.4019H16.065V40.3565H16.088V36.4019Z",
    fill: "#093346"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1118 36.4019H16.088V40.3565H16.1118V36.4019Z",
    fill: "#0A3448"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1348 36.4019H16.111V40.3565H16.1348V36.4019Z",
    fill: "#0B3549"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1578 36.4019H16.1348V40.3565H16.1578V36.4019Z",
    fill: "#0C354A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1816 36.4019H16.1578V40.3565H16.1816V36.4019Z",
    fill: "#0C364B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2054 36.4019H16.1816V40.3565H16.2054V36.4019Z",
    fill: "#0D374C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2276 36.4019H16.2046V40.3565H16.2276V36.4019Z",
    fill: "#0E384E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2514 36.4019H16.2276V40.3565H16.2514V36.4019Z",
    fill: "#0E394F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2751 36.4019H16.2513V40.3565H16.2751V36.4019Z",
    fill: "#0F3A50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2973 36.4019H16.2743V40.3565H16.2973V36.4019Z",
    fill: "#113B51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3212 36.4019H16.2974V40.3565H16.3212V36.4019Z",
    fill: "#133C52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.345 36.4019H16.3212V40.3565H16.345V36.4019Z",
    fill: "#133D53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3672 36.4019H16.3442V40.3565H16.3672V36.4019Z",
    fill: "#133E54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.391 36.4019H16.3672V40.3565H16.391V36.4019Z",
    fill: "#153F55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4147 36.4019H16.3909V40.3565H16.4147V36.4019Z",
    fill: "#154056"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4387 36.4019H16.4149V40.3565H16.4387V36.4019Z",
    fill: "#164157"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4607 36.4019H16.4377V40.3565H16.4607V36.4019Z",
    fill: "#184358"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4845 36.4019H16.4607V40.3565H16.4845V36.4019Z",
    fill: "#184359"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5084 36.4019H16.4845V40.3565H16.5084V36.4019Z",
    fill: "#19445A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5315 36.4019H16.5076V40.3565H16.5315V36.4019Z",
    fill: "#1A465B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5545 36.4019H16.5315V40.3565H16.5545V36.4019Z",
    fill: "#1B475C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5783 36.4019H16.5545V40.3565H16.5783V36.4019Z",
    fill: "#1B475D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6011 36.4019H16.5773V40.3565H16.6011V36.4019Z",
    fill: "#1C485E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6242 36.4019H16.6012V40.3565H16.6242V36.4019Z",
    fill: "#1D495F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.648 36.4019H16.6241V40.3565H16.648V36.4019Z",
    fill: "#1D4B61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6718 36.4019H16.648V40.3565H16.6718V36.4019Z",
    fill: "#1E4C62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6939 36.4019H16.671V40.3565H16.6939V36.4019Z",
    fill: "#1F4C63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7178 36.4019H16.694V40.3565H16.7178V36.4019Z",
    fill: "#1F4D64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7416 36.4019H16.7178V40.3565H16.7416V36.4019Z",
    fill: "#204E65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7638 36.4019H16.7408V40.3565H16.7638V36.4019Z",
    fill: "#214F66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7876 36.4019H16.7637V40.3565H16.7876V36.4019Z",
    fill: "#215067"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8114 36.4019H16.7876V40.3565H16.8114V36.4019Z",
    fill: "#215168"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8336 36.4019H16.8106V40.3565H16.8336V36.4019Z",
    fill: "#225269"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8574 36.4019H16.8336V40.3565H16.8574V36.4019Z",
    fill: "#23536A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8811 36.4019H16.8573V40.3565H16.8811V36.4019Z",
    fill: "#23536C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9034 36.4019H16.8804V40.3565H16.9034V36.4019Z",
    fill: "#24546D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.928 36.4019H16.9042V40.3565H16.928V36.4019Z",
    fill: "#25556D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.951 36.4019H16.9272V40.3565H16.951V36.4019Z",
    fill: "#25566E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.974 36.4019H16.951V40.3565H16.974V36.4019Z",
    fill: "#26576F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9978 36.4019H16.974V40.3565H16.9978V36.4019Z",
    fill: "#275971"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0208 36.4019H16.997V40.3565H17.0208V36.4019Z",
    fill: "#275972"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0446 36.4019H17.0208V40.3565H17.0446V36.4019Z",
    fill: "#285A73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0668 36.4019H17.0438V40.3565H17.0668V36.4019Z",
    fill: "#295A74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0906 36.4019H17.0668V40.3565H17.0906V36.4019Z",
    fill: "#295B74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1143 36.4019H17.0905V40.3565H17.1143V36.4019Z",
    fill: "#2A5C76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1374 36.4019H17.1136V40.3565H17.1374V36.4019Z",
    fill: "#2B5E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1604 36.4019H17.1374V40.3565H17.1604V36.4019Z",
    fill: "#2B5F78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1842 36.4019H17.1604V40.3565H17.1842V36.4019Z",
    fill: "#2C6079"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.208 36.4019H17.1842V40.3565H17.208V36.4019Z",
    fill: "#2D607A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2301 36.4019H17.2071V40.3565H17.2301V36.4019Z",
    fill: "#2D617B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2539 36.4019H17.2301V40.3565H17.2539V36.4019Z",
    fill: "#2E627C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2779 36.4019H17.254V40.3565H17.2779V36.4019Z",
    fill: "#2F637D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2999 36.4019H17.2769V40.3565H17.2999V36.4019Z",
    fill: "#31657E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3237 36.4019H17.2999V40.3565H17.3237V36.4019Z",
    fill: "#31657F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3476 36.4019H17.3238V40.3565H17.3476V36.4019Z",
    fill: "#326680"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3698 36.4019H17.3468V40.3565H17.3698V36.4019Z",
    fill: "#336681"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3945 36.4019H17.3707V40.3565H17.3945V36.4019Z",
    fill: "#336781"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4175 36.4019H17.3936V40.3565H17.4175V36.4019Z",
    fill: "#346882"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4404 36.4019H17.4174V40.3565H17.4404V36.4019Z",
    fill: "#356983"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4642 36.4019H17.4404V40.3565H17.4642V36.4019Z",
    fill: "#356A84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4871 36.4019H17.4633V40.3565H17.4871V36.4019Z",
    fill: "#376B85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5102 36.4019H17.4872V40.3565H17.5102V36.4019Z",
    fill: "#386C86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.534 36.4019H17.5101V40.3565H17.534V36.4019Z",
    fill: "#376D87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5571 36.4019H17.5332V40.3565H17.5571V36.4019Z",
    fill: "#386E88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.58 36.4019H17.557V40.3565H17.58V36.4019Z",
    fill: "#386F89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6039 36.4019H17.5801V40.3565H17.6039V36.4019Z",
    fill: "#396F8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6277 36.4019H17.6039V40.3565H17.6277V36.4019Z",
    fill: "#3A708B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6506 36.4019H17.6268V40.3565H17.6506V36.4019Z",
    fill: "#3A718C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6744 36.4019H17.6506V40.3565H17.6744V36.4019Z",
    fill: "#3B728D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6966 36.4019H17.6736V40.3565H17.6966V36.4019Z",
    fill: "#3C738E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7204 36.4019H17.6966V40.3565H17.7204V36.4019Z",
    fill: "#3C758F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7442 36.4019H17.7204V40.3565H17.7442V36.4019Z",
    fill: "#3D7690"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7665 36.4019H17.7435V40.3565H17.7665V36.4019Z",
    fill: "#3E7691"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7902 36.4019H17.7664V40.3565H17.7902V36.4019Z",
    fill: "#3E7692"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.814 36.4019H17.7902V40.3565H17.814V36.4019Z",
    fill: "#3F7893"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8363 36.4019H17.8133V40.3565H17.8363V36.4019Z",
    fill: "#407994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8608 36.4019H17.837V40.3565H17.8608V36.4019Z",
    fill: "#407A95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8838 36.4019H17.86V40.3565H17.8838V36.4019Z",
    fill: "#417A96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9067 36.4019H17.8837V40.3565H17.9067V36.4019Z",
    fill: "#2777c8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9305 36.4019H17.9067V40.3565H17.9305V36.4019Z",
    fill: "#427C98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9536 36.4019H17.9298V40.3565H17.9536V36.4019Z",
    fill: "#437C9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9766 36.4019H17.9536V40.3565H17.9766V36.4019Z",
    fill: "#437D9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0004 36.4019H17.9766V40.3565H18.0004V36.4019Z",
    fill: "#447E9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0234 36.4019H17.9996V40.3565H18.0234V36.4019Z",
    fill: "#447F9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0464 36.4019H18.0234V40.3565H18.0464V36.4019Z",
    fill: "#44809C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0702 36.4019H18.0464V40.3565H18.0702V36.4019Z",
    fill: "#45809D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0941 36.4019H18.0702V40.3565H18.0941V36.4019Z",
    fill: "#45819E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1162 36.4019H18.0932V40.3565H18.1162V36.4019Z",
    fill: "#46829F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1399 36.4019H18.1161V40.3565H18.1399V36.4019Z",
    fill: "#4683A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1637 36.4019H18.1399V40.3565H18.1637V36.4019Z",
    fill: "#4884A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.186 36.4019H18.163V40.3565H18.186V36.4019Z",
    fill: "#4884A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2098 36.4019H18.186V40.3565H18.2098V36.4019Z",
    fill: "#4885A2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_640_13290",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 13,
    width: 58,
    height: 36
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4418 38.5158C16.6709 38.5823 16.9033 38.6414 17.139 38.6932C17.1513 38.6956 17.1636 38.6956 17.1768 38.6973V38.7194C21.0222 39.7015 25.1361 39.6005 28.9914 38.6792C28.4068 40.1917 27.8558 41.7166 27.3705 43.2645C27.3171 43.4361 27.2637 43.6077 27.212 43.7793C25.3973 43.3663 23.6384 42.7611 21.9443 41.9884C20.7036 41.4226 19.5047 40.769 18.3625 40.0349L18.3682 40.0234C18.3682 40.0234 18.3247 40.0029 18.2566 39.9668C17.8912 39.7294 17.5315 39.4847 17.1776 39.231V39.2532C16.9206 39.0446 16.6611 38.7966 16.4435 38.5158M48.3894 42.8802C48.0618 42.6388 47.8803 41.9638 47.7202 41.6017C47.5321 41.1763 47.3581 40.7452 47.1938 40.31C47.1823 40.2796 47.1684 40.2533 47.1528 40.2287C48.4083 39.3854 49.594 38.4402 50.6919 37.3949C50.9112 38.7186 50.7009 40.0981 50.0966 41.3019C49.9118 41.6698 49.2303 42.9639 48.6349 42.9639C48.5504 42.9639 48.4682 42.9377 48.3894 42.8794M39.3543 33.4148C40.5639 32.3358 41.6601 31.1394 42.5781 29.8001C43.4264 28.5627 44.1318 27.2299 44.6359 25.8159C45.168 24.3231 45.3766 22.7957 45.6271 21.238C45.8874 19.6171 46.3464 18.0372 47.4812 16.8022C48.6325 15.5491 50.3101 14.9899 51.9778 15.3438C52.0214 15.3528 52.0624 15.3553 52.101 15.3512C52.2882 15.4604 52.4713 15.5795 52.6487 15.71C53.7137 16.4942 54.5529 17.5511 55.1475 18.7286C57.9747 24.3305 55.5835 30.843 51.7077 35.2435C47.5798 39.929 41.9204 42.8243 35.8497 44.0232C38.1908 41.0827 39.7279 37.1707 39.3543 33.4148ZM18.6951 31.9786C21.7703 31.9064 24.2099 30.2649 26.3679 28.212C30.8899 23.9125 34.9727 18.9946 40.6427 16.1379C43.1644 14.8675 46.0303 14.0218 48.8755 14.3486C49.2861 14.3962 49.6918 14.4652 50.0892 14.5604C49.0077 14.7436 47.9936 15.2527 47.1716 16.0401C44.6483 18.456 45.072 22.0748 44.0718 25.1483C43.1505 27.9821 41.3982 30.4973 39.227 32.5206C39.1072 31.8678 38.9257 31.2224 38.6769 30.5909C38.4995 30.1401 37.7851 30.3831 37.9633 30.8356C38.9306 33.2908 38.7984 35.9875 37.9986 38.4706C37.2817 40.6943 36.0484 42.7718 34.4611 44.4831C32.8245 46.2477 30.637 47.7414 28.2072 48.0871C27.928 48.1265 27.5823 48.1733 27.3163 48.051C27.0051 47.9081 27.0199 47.6166 27.0667 47.3144C27.1611 46.7002 27.3508 46.0818 27.5101 45.4816C27.8566 44.1801 28.2598 42.8933 28.704 41.6222C29.5769 39.121 30.5927 36.6731 31.6076 34.2269C31.7932 33.7802 31.1166 33.446 30.9302 33.8952C30.3882 35.2 29.8479 36.5056 29.3273 37.8203C25.458 38.8336 21.2628 38.9904 17.3673 37.9944C17.3451 37.9845 17.3213 37.9763 17.2966 37.9714C14.586 37.3818 12.3845 35.7945 10.7546 33.2522C9.52612 31.3373 9.10241 29.571 9.0983 29.5538C9.05232 29.3551 8.85442 29.2319 8.65571 29.2779C6.58723 29.7558 4.76511 29.5406 3.24024 28.6407C2.47164 28.1866 1.97485 27.6627 1.73096 27.3671C4.13529 25.1155 6.28012 26.238 6.37127 26.2881C6.43039 26.3209 6.49937 26.3193 6.56506 26.3341C8.2517 26.7151 8.24349 25.7519 8.33956 24.9742C8.88973 21.7759 10.7004 20.9818 11.3269 20.8003C13.3042 23.8805 10.4368 28.1168 10.4072 28.1603C10.3152 28.2933 10.3202 28.4699 10.4195 28.5971C12.7951 31.6518 17.0207 31.9055 17.1989 31.9146C17.2121 31.9146 17.2244 31.9138 17.2375 31.9129C17.6423 31.9597 18.0496 31.9844 18.4594 31.9844C18.5374 31.9844 18.6162 31.9836 18.6942 31.9819M40.6312 15.3118C34.8208 18.1365 30.6017 23.0823 26.0361 27.4927C24.8939 28.5963 23.6688 29.6728 22.2301 30.3749C20.8506 31.0483 19.3167 31.3135 17.7885 31.2117C17.584 31.1977 17.3804 31.178 17.1776 31.1526V31.1731C16.6816 31.1328 13.2188 30.7683 11.1668 28.3467C11.4304 27.9213 11.9797 26.9565 12.3615 25.7453C13.0488 23.5651 12.8518 21.6371 11.79 20.1697C11.7104 20.0597 11.5765 20.0014 11.4419 20.0202C11.3162 20.0367 8.35845 20.4826 7.60956 24.8601C7.60792 24.8675 7.60792 24.8691 7.6071 24.8765C7.59725 24.9439 7.49049 25.5211 6.62583 25.5917C6.39016 25.4825 5.77019 25.2386 4.92441 25.2321C3.95463 25.2255 2.48067 25.5375 0.97633 27.0723C0.855621 27.1946 0.835912 27.3843 0.928702 27.5296C0.953336 27.5691 1.55031 28.4929 2.82884 29.2582C3.94971 29.929 5.82357 30.5975 8.47505 30.0744C8.6631 30.7067 9.14757 32.1108 10.1198 33.6316C11.4714 35.7477 13.2648 37.2832 15.3719 38.1463C15.7504 39.0553 16.5494 39.7467 17.1784 40.1794V40.1811C20.1477 42.2249 23.516 43.7063 27.0018 44.5052C26.9148 44.8091 26.8302 45.1129 26.7497 45.4184C26.5732 46.0859 26.3326 46.7962 26.2874 47.4876C26.1995 48.8261 27.5585 48.978 28.5628 48.7892C31.1116 48.3096 33.3411 46.8192 35.0761 44.9314C35.8209 44.805 36.5616 44.6588 37.2965 44.4864C40.5573 43.7202 43.6974 42.4318 46.5156 40.6475C46.7323 41.2149 46.9664 41.7749 47.2242 42.3251C47.4336 42.7726 47.6323 43.3482 48.0987 43.5929C49.0619 44.0979 49.8979 43.0493 50.361 42.3489C51.4441 40.7091 51.7791 38.6734 51.3308 36.77C52.0829 36.0023 52.7899 35.1852 53.4436 34.3189C56.9573 29.6572 58.6382 22.8902 55.3848 17.6176C54.7065 16.5189 53.8065 15.5573 52.7218 14.8536C51.5681 14.1055 50.2378 13.7352 48.8772 13.5972C48.4691 13.5554 48.061 13.5356 47.6545 13.5356C45.2181 13.5356 42.8196 14.2484 40.6337 15.3118",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_640_13290)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.6349 13.5325H0.835083V48.9757H58.6349V13.5325Z",
    fill: "url(#paint8_linear_640_13290)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_640_13290",
    x1: 17.2261,
    y1: 30.07,
    x2: 57.5871,
    y2: 30.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8D3DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_640_13290",
    x1: 44.9627,
    y1: 19.3565,
    x2: 40.2116,
    y2: 26.324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#052335"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#052335"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#2E6079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4885A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_640_13290",
    x1: 19.3618,
    y1: 43.2107,
    x2: 53.1471,
    y2: 24.1037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4885A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8D3DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_640_13290",
    x1: 18.4327,
    y1: 41.6169,
    x2: 52.218,
    y2: 22.5098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4885A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8D3DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_640_13290",
    x1: 20.2718,
    y1: 44.788,
    x2: 54.0572,
    y2: 25.681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4885A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8D3DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_640_13290",
    x1: 19.2109,
    y1: 42.9871,
    x2: 52.9962,
    y2: 23.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4885A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8D3DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_640_13290",
    x1: 19.8476,
    y1: 44.1191,
    x2: 53.633,
    y2: 25.0121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4885A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8D3DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_640_13290",
    x1: 61.1602,
    y1: 16.1204,
    x2: 16.0815,
    y2: 46.4235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#052335"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#2E6079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4885A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_640_13290",
    x1: 0.752853,
    y1: 31.1629,
    x2: 57.0064,
    y2: 31.1629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#052335"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#2E6079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4885A2"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSvg);
export default __webpack_public_path__ + "static/media/logoSvg.cefefd189626f9d3a9d2fa924b2818c2.svg";
export { ForwardRef as ReactComponent };